<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div class="p-l" v-if="data">
          <div
            class="collapse available-techs"
            v-for="(techLevel, index) in Object.keys(data)"
            :key="index"
          >
            <div
              v-if="data[techLevel].length"
              class="collapse-title available-techs-title m-t"
              @click="toggleCollapse(techLevel)"
            >
              <i class="material-icons-outlined align-middle">{{
                levelstatus[techLevel] ? "arrow_drop_down" : "arrow_right"
              }}</i>
              {{ techLevel }}
              <span class="badge">{{ data[techLevel].length }}</span>
            </div>
            <div
              class="collapse-content flex flex-row flex-wrap"
              v-show="levelstatus[techLevel]"
            >
              <div
                class="main-pannel available-techs-panel flex-column"
                v-for="techData in data[techLevel]"
                :key="techData.id"
              >
                <div class="main-pannel-content flex-grow">
                  <div
                    class="tech-resume-info flex items-center justify-center"
                  >
                    <div class="flex-1">
                      <!-- <h3>{{(techData.name ? techData.name : techData.email) | getNameByEmail}}</h3> -->
                      <h3>{{ techData.name | getShorterName }}</h3>
                      <img
                        v-if="techData.windows"
                        width="16px"
                        height="16px"
                        src="@/assets/image/icon-windows.svg"
                        alt="windows"
                        class="os-icon"
                      />
                      <img
                        v-if="techData.mac"
                        width="16px"
                        height="16px"
                        src="@/assets/image/icon-apple.svg"
                        alt="apple"
                        class="os-icon"
                      />
                      <img
                        v-if="techData.linux"
                        width="16px"
                        height="16px"
                        src="@/assets/image/icon-linux.svg"
                        alt="linux"
                        class="os-icon"
                      />
                      <p>Location: {{ techData.metro }}</p>
                      <div>
                        <span
                          class="status-pill"
                          :class="{
                            red: !techData.is_active,
                            green: techData.is_active,
                          }"
                        ></span>
                        <span>{{
                          techData.is_active ? "Active" : "Inactive"
                        }}</span>
                        <div
                          v-if="techData.work_type"
                          class="available-techs-work-type"
                        >
                          {{ techData.work_type ? techData.work_type : "" }}
                        </div>
                      </div>
                    </div>
                    <div class="tech-resume-info-avatar">
                      <div class="tech-resume-info-avatar-container">
                        <span v-if="!techData.photo_url">{{
                          (techData.name ? techData.name : techData.email)
                            | getFirstLetter
                        }}</span>
                        <img v-else :src="techData.photo_url" alt />
                      </div>
                    </div>
                  </div>
                  <div class="dashboard-more-info">
                    <label>Title:</label>
                    <p>{{ techData.title ? techData.title : "none" }}</p>
                    <label>Rate:</label>
                    <p>
                      {{
                        techData.rate
                          ? techData.rate
                          : 0 | currencyFilter("$", 2)
                      }}
                    </p>
                    <label>Bio:</label>
                    <p class="available-techs-bio">
                      {{ techData.bio ? techData.bio : "none" }}
                    </p>
                    <label>Join Date:</label>
                    <p style="min-height: 24px">{{ techData.createdString }}</p>
                  </div>
                  <div v-if="techData.verified" class="verified-tag" />
                </div>
                <div class="main-pannel-foot">
                  <ul>
                    <li v-if="user && user.roles && user.roles.admin">
                      <a
                        href="javascript:void(0)"
                        @click="viewAsConsultant(techData)"
                        >View As</a
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{
                          name: 'resume',
                          params: { id: techData.id, type: 'allinfo' },
                        }"
                        target="_blank"
                        >Resume</router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { db } from "@/vendor/firebase";
import moment from "moment-timezone";
import CryptoJS from "crypto-js";

export default {
  data() {
    return {
      type: null,
      consultants: null,
      techLevels: null,
      levelstatus: null,
      data: null,
      techLevelsSort: null,
      editOpen: false,
      requestPropsData: null,
      requestSubmitLoading: false,
      filterData: {},
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  watch: {
    consultants: function () {
      this.updateData();
    },
    techLevels: function () {
      this.updateData();
    },
  },
  beforeMount() {
    this.getUrlParams();
    this.bindData();
  },
  methods: {
    getUrlParams: function () {
      this.type = this.$route.params.type;
      const code = this.$route.query.code;
      const decrypted = CryptoJS.AES.decrypt(code, "scaledesk");
      const data = JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
      this.filterData = data;
    },
    toggleCollapse: function (techLevel) {
      this.levelstatus[techLevel] = !this.levelstatus[techLevel];
      this.$forceUpdate();
    },
    bindData: function () {
      this.initConsultants();
      this.initTechLevels();
    },
    initConsultants: function () {
      db.collection("consultants")
        .get()
        .then((querySnapshot) => {
          this.consultants = querySnapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }));
        });
    },
    initTechLevels: function () {
      db.collection("tech_levels")
        .get()
        .then((querySnapshot) => {
          this.techLevels = querySnapshot.docs.map((doc) => doc.data());
        });
    },
    updateData: function () {
      if (this.consultants && this.techLevels) {
        this.data = {};
        this.techLevelsSort = this.techLevels.slice();
        this.techLevelsSort.sort((a, b) => {
          if (a.order === null || a.order === undefined) return 1;
          if (b.order === null || b.order === undefined) return -1;
          return a.order - b.order;
        });
        this.levelstatus = {};
        for (const i in this.techLevelsSort) {
          if (!this.data[this.techLevelsSort[i].name]) {
            this.data[this.techLevelsSort[i].name] = [];
            this.levelstatus[this.techLevelsSort[i].name] = true;
          }
        }
        this.data["general"] = [];
        this.levelstatus["general"] = true;
        for (const i in this.consultants) {
          if (this.consultants[i].created) {
            this.consultants[i].createdString = moment(
              this.consultants[i].created * 1000
            ).format("MM/DD/YYYY");
          }
          if (this.consultants[i].resume && this.consultants[i].resume.skills) {
            const skills = this.consultants[i].resume.skills;
            if (skills.indexOf("Windows OS") > -1)
              this.consultants[i].windows = true;
            if (skills.indexOf("Mac OS") > -1) this.consultants[i].mac = true;
            if (skills.indexOf("Linux OS") > -1)
              this.consultants[i].linux = true;
          }
          if (this.consultants[i].is_active) {
            if (
              !this.filterData.skill ||
              (this.filterData.skill &&
                this.consultants[i].resume &&
                this.consultants[i].resume.skills &&
                this.consultants[i].resume.skills.indexOf(
                  this.filterData.skill
                ) > -1)
            ) {
              if (
                !this.filterData.certification ||
                (this.filterData.certification &&
                  this.consultants[i].resume &&
                  this.consultants[i].resume.certifications &&
                  this.consultants[i].resume.certifications.some(
                    (item) => item.description === this.filterData.certification
                  ))
              ) {
                if (
                  !this.filterData.metro ||
                  this.consultants[i].metro === this.filterData.metro
                ) {
                  if (
                    !this.filterData.level ||
                    this.consultants[i].tech_level === this.filterData.level
                  ) {
                    if (
                      !this.filterData.worktypes ||
                      this.hasWorkType(
                        this.consultants[i].work_type,
                        this.filterData.worktypes
                      )
                    ) {
                      if (
                        !this.filterData.search ||
                        JSON.stringify(this.consultants[i])
                          .toLowerCase()
                          .indexOf(this.filterData.search.toLowerCase()) > -1
                      ) {
                        if (
                          this.filterData.verified === undefined ||
                          this.filterData.verified === null ||
                          this.filterData.verified ===
                            this.consultants[i].verified
                        ) {
                          if (this.consultants[i].tech_level) {
                            if (this.data[this.consultants[i].tech_level]) {
                              this.data[this.consultants[i].tech_level].push(
                                this.consultants[i]
                              );
                            }
                          } else {
                            this.data["general"].push(this.consultants[i]);
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        Object.keys(this.data).forEach((item) => {
          this.data[item].sort((a, b) => {
            if (a.verified !== b.verified) {
              if (a.verified) return -1;
              if (b.verified) return 1;
            }
            if (!a.created) return 1;
            if (!b.created) return -1;
            return b.created - a.created;
          });
        });
      }
    },
    hasWorkType: function (workType, workTypeFilter) {
      if (!workTypeFilter) return true;
      if (!workType) return false;
      const workTypeArray = workType.split(",");
      const workTypeFilterArray = workTypeFilter.split(",");
      let returnValue = false;
      returnValue = workTypeFilterArray.every((item) => {
        return workTypeArray.indexOf(item) > -1;
      });
      return returnValue;
    },
  },
};
</script>

<style scoped>
.verified-tag {
  position: absolute;
  top: 0;
  right: 0;
}
.verified-tag::before,
.verified-tag::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  border-color: transparent;
  border-style: solid;
}

.verified-tag::before {
  border-width: 16px;
  border-right-color: transparent;
  border-top-color: transparent;
}

.verified-tag::after {
  border-width: 16px;
  border-right-color: #437512;
  border-top-color: #437512;
}
.flex-column {
  display: flex;
  flex-direction: column;
}
.flex-grow {
  flex-grow: 1;
}
.os-icon {
  opacity: 0.4;
  margin-right: 4px;
}
</style>
